import {
  appendToEditorDOM,
  appendToEditorDOMWithCallback,
  getCitationRefNode,
} from 'src/researcher/utils';
import {
  CitationData,
  CitationGeneratorReduxState,
  CitationListAction,
  CitationSourceEnum,
} from 'src/citation-generator/types';
import {
  addCitationToList,
  rebuildCitationNumbers,
  updateCitedData,
} from 'src/citation-generator/reducers/actionCreators';
import { Months } from 'src/citation-generator/constants';
import { generateRandomId } from 'core/utils';
import { ThunkAction } from 'redux-thunk';
import { RootState } from '@Common/models/redux/store';
import { ContextMenuContainer } from 'src/researcher/types/contextmenu';
import { generateCitations } from 'src/researcher/handlers/api';
import { convertCitedDataResponse } from 'src/citation-generator/utils';
import { SelectionEndMenuTypes } from 'src/researcher/models';
import { updateMousePosition } from './actionCreators';

/**
 * Note: This is a redux middleware dispatch function and doesn't belong here. Should have been a util instead.
 */
export const addTextWithCitation =
  (
    style: string,
    metaInfo: CitationData,
    text: string,
    withQuotes = true,
    appendToNewLine = true
  ): ThunkAction<Promise<void>, RootState, null, CitationListAction> =>
  async (dispatch, getState) => {
    const citationState: CitationGeneratorReduxState = getState().ctgr;
    metaInfo.refId = metaInfo.refId || generateRandomId();
    const { citationsFromCowriter: citations, citationStyle, citedDataById } = citationState;

    if (!metaInfo.publicationInfo?.title) {
      appendToEditorDOM(style, text, undefined, withQuotes, appendToNewLine);
    }

    if (metaInfo.citationSource === CitationSourceEnum.WEBSITE) {
      const today = new Date();
      const defaultDateAccessed = {
        day: today.getDate(),
        month: Months[today.getMonth()],
        year: today.getFullYear(),
      };
      metaInfo.publicationInfo.accessDate = defaultDateAccessed;
    }
    const existing = citations?.find((c) => c.publicationInfo.url === metaInfo.publicationInfo.url);
    if (existing) {
      appendToEditorDOM(
        style,
        text,
        getCitationRefNode(existing, citedDataById[existing.refId]),
        withQuotes,
        appendToNewLine
      );
    } else {
      const insertCb = appendToEditorDOMWithCallback(style, text, withQuotes, appendToNewLine);
      const response = await generateCitations({ style: citationStyle, citations: [metaInfo] });
      const citedData = convertCitedDataResponse(response);
      citedData[0].citationNumber = citations.length;
      dispatch(updateCitedData(citedData));
      dispatch(addCitationToList(metaInfo));
      dispatch(rebuildCitationNumbers());
      insertCb(getCitationRefNode(metaInfo, citedData[0]));
      if (response.style !== citationStyle) {
        // TODO: handle this
      }
    }
  };

// get selection text
export const getSelectionText = (): string => {
  let text = '';
  if (window?.getSelection) {
    text = window?.getSelection?.()?.toString?.() || '';
  } else if (document.selection) {
    text = document.selection.createRange().text;
  }
  return text;
};

export const onContextMenuHelperFn =
  (
    contextMenuDispatch: Function,
    contextMenuContainer: ContextMenuContainer,
    selectionEndMenu: SelectionEndMenuTypes
  ) =>
  (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const { clientX, clientY } = e;
    const mousePosition = {
      mouseX: clientX,
      mouseY: clientY,
    };

    contextMenuDispatch(
      updateMousePosition({
        mousePosition,
        contextMenuContainer,
        selectionEndMenu,
      })
    );
  };
